module.exports = __webpack_public_path__ + "static/billing-40fe1cb43cc165feb37f7d6d99d80b74.svg";